<template>
  <div class="level">
    <div class="jiangli_top">
      <icon name="arrow-left" @click="$router.go(-1)" />
      <p>{{ $t("m.jl_span0") }}</p>
    </div>
    <div class="level_con">
      <list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('m.gengduo')"
        @load="getData"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          class="record-item"
        >
          <div class="record-main">
            <icon
              name="balance-list-o"
              class="record-icon"
              size="22"
              color="#1769b0"
            />
            <div class="record-info">
              <div class="record-title">USD 提现</div>
              <div class="record-detail">
                {{ $t("m.jf_span7") }}：{{ item.remark }}
              </div>
              <div class="record-detail">
                {{ $t("m.jl_span3") }}：{{ item.reply }}
              </div>
              <div class="record-date">
                {{ createDate(item.created_at) }}
              </div>
            </div>
          </div>
          <div class="record-status">
            <strong>-{{ item.money }} USD</strong>
            <div v-if="item.fee > 0" class="record-fee">
              手续费：{{ item.fee }} USD
            </div>
            <div class="status-text">
              <span v-if="item.status === 0">{{ $t("m.jl_span4") }}</span>
              <span v-if="item.status === 1">{{ $t("m.jl_span5") }}</span>
              <span v-if="item.status === 2">{{ $t("m.jl_span6") }}</span>
              <span v-if="item.status === 3">{{ $t("m.jl_span7") }}</span>
            </div>
          </div>
        </div>
      </list>
    </div>
  </div>
</template>

<script>
import { getWithdraw } from "../../../api/user";
import Icon from "vant/lib/icon";
import List from "vant/lib/list";
import "vant/lib/list/style";
export default {
  name: "index",
  components: {
    Icon,
    List
  },
  data() {
    return {
      currentDate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      show: false,
      list: [],
      loading: false,
      finished: false,
      page: 1
    };
  },
  computed: {
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return y + "-" + MM + "-" + d + " " + h + ":" + m;
      };
    }
  },
  methods: {
    getData() {
      getWithdraw({ page: this.page }).then(res => {
        console.log(res.data.data);
        if (res.data.data.length > 0) {
          this.list = this.list.concat(res.data.data);
          this.page++;
        } else {
          this.finished = true;
        }
        this.loading = false;
      });
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    }
  }
};
</script>

<style scoped>
.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  position: relative;
}
.jiangli_top i {
  position: absolute;
  top: 13px;
  left: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 24px;
}
.level_con {
  padding: 20px 15px;
}
.record-item {
  display: flex;
  margin-bottom: 10px;
  padding: 15px;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid rgba(40, 79, 119, 0.07);
  border-radius: 14px;
  box-shadow: 0 9px 24px rgba(20, 53, 88, 0.065);
}
.record-main {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
}
.record-icon {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  margin-right: 10px;
  place-items: center;
  background: #e9f3fb;
  border-radius: 11px;
}
.record-info {
  min-width: 0;
}
.record-title {
  margin-bottom: 6px;
  color: #23364d;
  font-size: 13px;
  font-weight: 650;
}
.record-detail {
  margin-bottom: 4px;
  color: #748195;
  font-size: 10px;
  line-height: 1.4;
}
.record-date,
.record-fee {
  color: #9aa5b4;
  font-size: 9px;
}
.record-status {
  flex: 0 0 auto;
  margin-left: 12px;
  color: #31465f;
  text-align: right;
}
.record-status strong {
  display: block;
  margin-bottom: 5px;
  color: #a9332c;
  font-size: 13px;
}
.status-text {
  margin-top: 5px;
  color: #658099;
  font-size: 9px;
}
</style>

